import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

const LogoFacebook: React.FC<IIconProps> = ({
  size = IconSizes.md,
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      width={IconWidth[size]}
      height={IconHeight[size]}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={UNSAFE_className || ''}
      {...props}
    >
      <g clipPath="url(#clip0_1268_180)">
        <path
          d="M30 17C30 9.82036 24.1796 4 17 4C9.82036 4 4 9.82036 4 17C4 23.0965 8.19744 28.2122 13.8597 29.6173V20.9728H11.1791V17H13.8597V15.2882C13.8597 10.8635 15.8622 8.8126 20.2063 8.8126C21.03 8.8126 22.4512 8.97432 23.0325 9.13552V12.7365C22.7257 12.7043 22.1927 12.6882 21.5308 12.6882C19.3993 12.6882 18.5756 13.4957 18.5756 15.595V17H22.8219L22.0924 20.9728H18.5756V29.9048C25.0127 29.1274 30 23.6466 30 17Z"
          fill="#0866FF"
        />
        <path
          d="M22.0924 20.9728L22.8219 17H18.5756V15.595C18.5756 13.4957 19.3993 12.6882 21.5308 12.6882C22.1927 12.6882 22.7257 12.7043 23.0325 12.7365V9.13552C22.4512 8.97432 21.03 8.8126 20.2063 8.8126C15.8622 8.8126 13.8597 10.8635 13.8597 15.2882V17H11.1791V20.9728H13.8597V29.6173C14.8654 29.8669 15.9168 30 16.9995 30C17.5325 30 18.0592 29.9672 18.5756 29.9048V20.9728H22.0924Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1268_180">
          <rect
            width="26"
            height="26"
            fill="white"
            transform="translate(4 4)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LogoFacebook;
